import { useEffect, useState } from 'react';

export const usePersistentTabState = (
  storageKey: string,
  defaultValue: string,
  allowedValues?: string[]
) => {
  const readValue = (): string => {
    if (typeof window === 'undefined') {
      return defaultValue;
    }

    const saved = window.localStorage.getItem(storageKey);
    if (!saved) {
      return defaultValue;
    }

    if (allowedValues && !allowedValues.includes(saved)) {
      return defaultValue;
    }

    return saved;
  };

  const [value, setValue] = useState<string>(readValue);

  useEffect(() => {
    setValue(readValue());
    // Re-evaluate when storage key changes (different page/component scope).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storageKey]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    window.localStorage.setItem(storageKey, value);
  }, [storageKey, value]);

  return [value, setValue] as const;
};
